export enum ViolationType {
  VIOLATION_TYPE_UNKNOWN = 0,
  VIOLATION_TYPE_VIOLENCE = 1,
  VIOLATION_TYPE_HARASSMENT = 2,
  VIOLATION_TYPE_PRIVACY = 3,
  VIOLATION_TYPE_RIGHTS = 4,
  VIOLATION_TYPE_ADULT = 5,
  VIOLATION_TYPE_SPAM = 6,
  VIOLATION_TYPE_OTHER = 7,
}
